<div *ngIf="!quickBooksRealm" fxLayoutAlign="center center">
  <button mat-raised-button color="primary" (click)="connectToQB()">
    Connect to QuickBooks
  </button>
</div>
<div *ngIf="quickBooksRealm">
  <div *ngIf="!quickBooksCompany">
    Checking Purchase Invoices, please wait
  </div>
  <div class="container" *ngIf="quickBooksCompany">
    <div class="header">
      <div class="header-row">
        Viewing data to export for {{quickBooksCompany.CompanyName}}
        <button mat-raised-button color="primary" (click)="connectToQB()">
          Switch Company
        </button>
      </div>
      <div class="header-row">
        <mat-radio-group class="export-radio-group" [(ngModel)]="qbObject" (change)="getData()">
          <mat-radio-button class="export-radio-button" value="Payments">
            Payments
          </mat-radio-button>
          <mat-radio-button class="export-radio-button" value="PurchaseInvoices">
            Purchase Invoices
          </mat-radio-button>
          <mat-radio-button class="export-radio-button" value="SalesInvoices">
            Sales Invoices
          </mat-radio-button>
          <mat-radio-button class="export-radio-button" value="Clients">
            Clients
          </mat-radio-button>
        </mat-radio-group>

        <button *ngIf="qbObject && qbObject !== 'Clients'" mat-raised-button color="primary" (click)="getData()">
          Refresh
        </button>

        <button mat-raised-button color="primary" (click)="reconcileData()">
          Create Reconciliation Spreadsheet
        </button>
      </div>
    </div>

    <div class="table-container" *ngIf="qbObject && qbObject !== 'Clients'">
      <form [formGroup]="form">
        <mat-table [dataSource]="dataSource" matSort formArrayName="formArray">
          <ng-container cdkColumnDef="Select">
            <mat-header-cell *cdkHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
            </mat-header-cell>
            <mat-cell *cdkCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"></mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container cdkColumnDef="Exists">
            <mat-header-cell *cdkHeaderCellDef>On Quickbooks?</mat-header-cell>
            <mat-cell *cdkCellDef="let row">
              <mat-checkbox (click)="$event.preventDefault()" [checked]="row.controls['Exists'].value"></mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container cdkColumnDef="CompanyName">
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>Company Name</mat-header-cell>
            <mat-cell *cdkCellDef="let row;" [formGroupName]="dataSource.data.indexOf(row)">
              <ng-container *ngIf="row.controls['Exists'].value == null || row.controls['Exists'].value">

                <ng-container *ngIf="getValidAccount(row) as valAcc; else nameMatches">
                  <ng-container *ngIf="(valAcc.CompanyName.toLowerCase() === row.controls['CompanyName'].value.toLowerCase()); then nameMatches else nameNoMatch"></ng-container>
                  <ng-template #nameNoMatch>
                    <div>COAD Name: {{row.controls['CompanyName'].value}}</div>
                    <div>QB Name: {{valAcc.CompanyName}}</div>
                  </ng-template>
                </ng-container>
                <ng-template #nameMatches>{{row.controls['CompanyName'].value}}</ng-template>

                <div *ngIf="row.controls['Errors']?.value">
                  <mat-error>
                    <div *ngFor="let error of row.controls['Errors']?.value?.Errors">{{error}}</div>
                    <div *ngIf="row.controls['Errors']?.value?.Documents?.length">Some documents failed to export</div>
                  </mat-error>
                </div>
              </ng-container>
              <ng-container *ngIf="row.controls['Exists'].value != null && !row.controls['Exists'].value">
                <mat-form-field>
                  <input matInput formControlName="CompanyName" [matAutocomplete]="autoName" (input)="updateAutocompleteNames(row, 'CompanyName')" (focus)="updateAutocompleteNames(row, 'CompanyName')" />
                  <mat-autocomplete #autoName="matAutocomplete" (optionSelected)="supplierSelected(row, 'CompanyName', $event.option.value)">
                    <mat-option *ngFor="let option of nameOptions$ | async" [value]="option">
                      {{option.CompanyName}} ({{option.AccountNo}}) - {{option.Currency}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="row.controls['Errors']?.value || row.controls['CompanyName']?.invalid">
                    <ng-container *ngIf="row.controls['CompanyName'].errors.required">Enter a company name</ng-container>
                    <ng-container *ngIf="row.controls['CompanyName'].errors.maxlength">Name cannot be more than 300 characters</ng-container>
                    <ng-container *ngFor="let error of row.controls['Errors']?.value?.Errors">{{error}}</ng-container>
                    <ng-container *ngIf="row.controls['Errors']?.value?.Documents?.length">Some documents failed to export</ng-container>
                  </mat-error>
                </mat-form-field>
              </ng-container>
            </mat-cell>
          </ng-container>

          <ng-container cdkColumnDef="AccountNo">
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>Account No</mat-header-cell>
            <mat-cell *cdkCellDef="let row;" [formGroupName]="dataSource.data.indexOf(row)">
              <ng-container *ngIf="qbObject !== 'PurchaseInvoices' || row.controls['Exists'].value == null || row.controls['Exists'].value">
                {{row.controls['AccountNo'].value}}
              </ng-container>
              <ng-container *ngIf="qbObject === 'PurchaseInvoices' && !(row.controls['Exists'].value == null || row.controls['Exists'].value)">
                <mat-form-field>
                  <input matInput formControlName="AccountNo" [matAutocomplete]="autoAccNo" (input)="updateAutocompleteNames(row, 'AccountNo')" (focus)="updateAutocompleteNames(row, 'AccountNo')" />
                  <mat-autocomplete #autoAccNo="matAutocomplete" panelWidth="auto" (optionSelected)="supplierSelected(row, 'AccountNo', $event.option.value)">
                    <mat-option *ngFor="let option of nameOptions$ | async" [value]="option">
                      {{option.CompanyName}} ({{option.AccountNo}}) - {{option.Currency}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="row.controls['AccountNo']?.invalid">
                    <ng-container *ngIf="row.controls['AccountNo'].errors.required">Enter an account reference</ng-container>
                    <ng-container *ngIf="row.controls['AccountNo'].errors.maxlength">Reference too long</ng-container>
                  </mat-error>
                </mat-form-field>
              </ng-container>
            </mat-cell>
          </ng-container>
          
          <ng-container cdkColumnDef="Currency">
            <mat-header-cell *cdkHeaderCellDef>Currency</mat-header-cell>
            <mat-cell *cdkCellDef="let row">
              {{row.value['Currency']}}
            </mat-cell>
          </ng-container>
          
          <ng-container cdkColumnDef="ToExport">
            <mat-header-cell *cdkHeaderCellDef>To Export</mat-header-cell>
            <mat-cell *cdkCellDef="let row">
              <a mat-button [color]="row.value['Errors']?.Documents && row.value['Errors'].Documents.length > 0 ? 'warn' : ''" (click)="showToExport(row)">{{row.value['ToExport']}}</a>
            </mat-cell>
          </ng-container>
          
          <ng-container cdkColumnDef="MissingVAT">
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>Missing VAT</mat-header-cell>
            <mat-cell *cdkCellDef="let row">
              <a mat-button *ngIf="row.value['MissingVAT'] > 0" color='warn' (click)="showMissingVAT(row)">{{row.value['MissingVAT']}}</a>
              <span *ngIf="row.value['MissingVAT'] === 0">0</span>
            </mat-cell>
          </ng-container>
          
          <ng-container cdkColumnDef="Value">
            <mat-header-cell *cdkHeaderCellDef>Value</mat-header-cell>
            <mat-cell *cdkCellDef="let row">
              {{row.value['Value'] | currency: row.value['Currency']}}
            </mat-cell>
          </ng-container>
          
          <ng-container cdkColumnDef="Oldest">
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>Date of Oldest Item</mat-header-cell>
            <mat-cell *cdkCellDef="let row">
              {{row.value['Oldest'] | date:'d MMM yyyy':'UTC'}}
            </mat-cell>
          </ng-container>

          <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *cdkRowDef="let row; columns: displayedColumns;"          
            [ngClass]="{
              'selected': selection.isSelected(row),
              'ok': (row.controls['Exists'].value == null || row.controls['Exists'].value) && (qbObject !== 'PurchaseInvoices' || row.value['MissingVAT'] == 0),
              'missing-vat': (row.controls['Exists'].value == null || row.controls['Exists'].value) && (qbObject === 'PurchaseInvoices' && row.value['MissingVAT'] > 0),
              'bad': row.controls['Exists'].value != null && !row.controls['Exists'].value && (!row.controls['CompanyName']?.value?.length || row.controls['CompanyName']?.invalid || !row.controls['AccountNo']?.value?.length || row.controls['AccountNo']?.invalid),
              'new': row.controls['Exists'].value != null && !row.controls['Exists'].value && row.controls['CompanyName']?.value?.length && !row.controls['CompanyName']?.invalid && row.controls['AccountNo']?.value?.length && !row.controls['AccountNo']?.invalid
            }"
          ></mat-row>
        </mat-table>
      </form>
    </div>

    <div class="footer">
      <button *ngIf="selection.selected.length > 0" mat-raised-button color="primary" (click)="doPreExportChecks()">
        Export to QuickBooks
      </button>
    </div>
  </div>
</div>
